import {fetch} from "utils/dataAccess";

export async function getModificationLog(productId, page = 1) {
    const response = await fetch(`/products/${productId}/modification-logs?page=${page}&limit=50`);

    return await response.json();
}
